import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { TUsersState } from '../../types'
import { usersService } from '../../../services'
import { parseHttpError } from '../../utils'
import { parseUsers } from './utils'
import { selectors } from './selectors'
import { usersAdapter } from './adapter'

const name = 'users'

const initialState: TUsersState = {
    ...usersAdapter.getInitialState(),
    isFetching: false
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async () => {
        return parseUsers(await usersService.fetch())
    },
    {
        serializeError: parseHttpError
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                usersAdapter.setAll(state, action.payload)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const users = {
    name: slice.name,
    actions: {
        fetch,
    },
    reducer: slice.reducer,
    selectors,
}